import { RootState } from '../store'
export const selectDelais = (state: RootState) => state.delai.delais
export const selectLoading = (state: RootState) => state.delai.loading
export const selectError = (state: RootState) => state.delai.error
